module.exports = __webpack_public_path__ + "img/eye-closed.42a9bf67.svg";